import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrokerHeaderComponent } from './broker-header.component';
import { LeadFormModule } from 'src/app/shared/components/lead-form/lead-form.module';
import { BrokerModalEditionModule } from '../broker-modal-edition/broker-modal-edition.module';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    LeadFormModule,
    BrokerModalEditionModule,
    SharedModule
  ],
  declarations: [BrokerHeaderComponent],
  exports: [BrokerHeaderComponent],
})
export class BrokerHeaderModule {}
